
import React from 'react';
import MarkdownRenderer from '../MarkdownRenderer';
import { WebSearchData } from '@/types/webSearch';

interface WebSearchContentProps {
  searchData: WebSearchData | null;
}

const WebSearchContent: React.FC<WebSearchContentProps> = ({ searchData }) => {
  if (!searchData) {
    return <p className="text-muted-foreground py-2">No web search data available.</p>;
  }

  const content =
    (searchData.summary && searchData.summary.trim()) ||
    (searchData.rawText && searchData.rawText.trim()) ||
    '';

  if (!content) {
    return <p className="text-muted-foreground py-2">No summary available yet. Try refreshing or check Sources.</p>;
  }

  return <MarkdownRenderer content={content} />;
};

export default WebSearchContent;
